import * as React from 'react';
import * as ReactDOM from 'react-dom';
import Listings from './Listings';

const catalog_number = +window.location.href.substr(window.location.href.lastIndexOf('/') + 1);

ReactDOM.render(
  <Listings catalog_number={catalog_number} />,
  document.getElementById('marketplace-listing')
);